import React from 'react'

import {
  
  ParisSaintGermain,
  ASMonaco,
  Lyon,
  Marseille,
  Bordeaux,
  SaintEtienne,
  Nantes,
  Reims,
  Nice,
  Lille,
  Toulouse,

} from "../clubs";

const Ligue1 = () => {
  return (
    <div>
      <h1>Dates of the last league titles for each club that has won Ligue 1.</h1>
      <ParisSaintGermain />
      <Lille />
      <ASMonaco />
      <Marseille />
      <Bordeaux />
      <Lyon />
      <Nantes />
      <SaintEtienne />
      <Reims />
      <Nice />
      <Toulouse  />
    </div>
  )
}

export default Ligue1;

